module.exports = __webpack_public_path__ + "static/img/winbg.b1e79937.png";